import {
  legalAcceptanceLocalStorageKey,
  legalAcceptanceSoftDismissSessionKey,
} from "./legalAcceptanceStorageKey";

export type LegalAcceptanceLocalPayload = {
  termsVersion: string;
  privacyVersion: string;
};

export function readLegalAcceptanceFromLocalStorage(): LegalAcceptanceLocalPayload | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(legalAcceptanceLocalStorageKey);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as LegalAcceptanceLocalPayload;
    if (
      typeof parsed.termsVersion === "string" &&
      typeof parsed.privacyVersion === "string"
    ) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeLegalAcceptanceToLocalStorage(payload: LegalAcceptanceLocalPayload): void {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(legalAcceptanceLocalStorageKey, JSON.stringify(payload));
}

export function readSoftDismissToken(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  return window.sessionStorage.getItem(legalAcceptanceSoftDismissSessionKey);
}

export function writeSoftDismissToken(token: string): void {
  if (typeof window === "undefined") {
    return;
  }
  window.sessionStorage.setItem(legalAcceptanceSoftDismissSessionKey, token);
}
